<template>
  <ResizablePage>
    <template v-slot:content="contentProps">
      <v-data-table
        :headers="headers"
        :items="persons"
        :items-per-page="-1"
        :height="contentProps.tableHeight"
        tableProps.tableHeight
        fixed-header
        hide-default-footer
        :search="fastFilter"
        :item-class="rowStyle"
        :custom-filter="customFilter"
        @click:row="rowClick"
        @contextmenu:row="rowMenuClick"
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ formatName(item) }}
        </template>
        <template v-slot:[`item.access`]="{ item }">
          {{ $t("enum.person_access." + item.access) }}
        </template>
        <template v-slot:[`item.login`]="{ item }">
          {{ (item.login === null) ? "-" : item.login }}
        </template>
      </v-data-table>

      <v-menu
        v-model="contextMenu"
        :position-x="contextMenuX"
        :position-y="contextMenuY"
        absolute
        offset-y
      >
        <v-list>
          <template v-for="(item, index) in contextItems">
            <v-divider class="mx-3" :key="index" v-if="item.topBorder" />
            <v-list-item v-if="item.enabled"
                         :key="index"
                         link
                         @click="rowMenuItemClick(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </template>
  </ResizablePage>
</template>

<script>
//import Vue from "vue";
import utils from "@/utils";
import ResizablePage from "@/components/ResizablePage";

export default {
  name: "SpecialAccessesView",
  components: { ResizablePage },
  data() {
    return {
      mounted: false,
      contextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      contextPerson: null,
      contextItems: [],

      headers: [
        {
          text: this.$t("table.special-accesses.header.name"),
          align: "start",
          sortable: true,
          width: "40%",
          value: "name"
        },
        {
          text: this.$t("table.special-accesses.header.access"),
          align: "start",
          sortable: true,
          width: "30%",
          value: "access"
        },
        {
          text: this.$t("table.special-accesses.header.login"),
          align: "start",
          sortable: true,
          width: "30%",
          value: "login"
        }
      ]
    };
  },

  computed: {
    fastFilter: function() {
      return this.$store.state.data.fastFilter;
    },

    persons: function() {
      if (this.$store.state.data.records === null || this.$store.state.data.module !== "special-access")
        return [];
      else
        return this.$store.state.data.records;
    }
  },

  methods: {
    customFilter(value, search, item) {
      let ls = search.toLowerCase();
      return (item.firstName !== null && item.firstName.toLowerCase().includes(ls))
        || (item.lastName !== null && item.lastName.toLowerCase().includes(ls))
        || (item.login !== null && item.login.toLowerCase().includes(ls))
        || (item.access !== null && item.access.toLowerCase().includes(ls));
    },

    formatName(person) {
      return utils.formatName(person.firstName, person.lastName);
    },

    rowClick(item) {
      this.$router.push({ name: "data/special-access", params: { id: item.personId } });
    },

    rowMenuClick(event, item) {
      this.contextMenuX = event.clientX;
      this.contextMenuY = event.clientY;
      this.contextMenu = true;
      this.contextPerson = item.item;

      event.preventDefault();
    },

    // eslint-disable-next-line no-unused-vars
    rowMenuItemClick(item) {
    },

    rowStyle: function(item) {
      if (item.active !== true)
        return "table-row-hidden";
      else
        return "";
    }
  },

  watch: {},

  mounted() {
    this.mounted = true;
    this.$store.dispatch("data/fetchRecords", { module: "special-access" });
  },

  destroyed() {
    this.mounted = false;
  }
};
</script>

<style scoped>

</style>